import axios from 'axios';
import config from './config';

const API_BASE_URL = `${config.API_BASE_URL}/Rentals`;

export const fetchRentalProducts = async (branchId, currency = 'YER') => {
  const params = [];
  if (branchId) params.push(`branchId=${branchId}`);
  if (currency) params.push(`currency=${currency}`);
  const query = params.length > 0 ? `?${params.join('&')}` : '';
  const response = await axios.get(`${API_BASE_URL}/products${query}`);
  return response.data;
};

export const checkRentalAvailability = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/check-availability`, data);
  return response.data;
};

export const createRentalOrder = async (orderData) => {
  const response = await axios.post(`${API_BASE_URL}/orders`, orderData);
  return response.data;
};

export const fetchCustomerRentals = async (customerId, currency = 'YER', status) => {
  const params = [`currency=${currency}`];
  if (status) params.push(`status=${status}`);
  const query = `?${params.join('&')}`;
  const response = await axios.get(`${API_BASE_URL}/orders/customer/${customerId}${query}`);
  return response.data;
};

export const cancelRental = async (rentalId, customerId) => {
  const response = await axios.post(`${API_BASE_URL}/orders/${rentalId}/cancel`, { CustomerId: customerId });
  return response.data;
};

export const fetchRentalPriceTypes = async () => {
  const response = await axios.get(`${API_BASE_URL}/price-types`);
  return response.data;
};